import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { getMarkets } from '../utils/getMarkets'

/** Get all available markets with feature flag-aware locale support. */
export function useMarkets(): Record<MarketCountryCode, Market> {
  const publicConfig = useRuntimeConfig().public
  const enableEsUsLocale = Boolean(publicConfig.FF_ENABLE_ES_US_LOCALE)

  return getMarkets(enableEsUsLocale)
}
